<div class="time-card">
    <mat-icon style="color:grey;">alarm</mat-icon>
    <mat-select
          placeholder="Select Time"
          matNativeControl
          [(ngModel)]="selectedTime"
          style="background: #f0f0f0;margin-left:6px;padding: 3px 5px"
        >
          <mat-option *ngFor="let ftime of timeList" [value]="ftime"  (mousedown)="getTimeValue(ftime)">{{ftime}}</mat-option>
        </mat-select>

    <!-- <input type="text" placeholder="Set time"  [(ngModel)]="selectedTime"  pattern="((([1-9])|(1[0-2])):([0-5])([0-9])\s(A|P)M)" 
    cdkOverlayOrigin (click)="isOpen=!isOpen"autocomplete="off"
    #trigger="cdkOverlayOrigin"
        name="time"style="position:relative;border:none; outline:none; margin-left:4px;">
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayHasBackdrop]="true"
        cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
        [cdkConnectedOverlayOpen]="isOpen" (backdropClick)="isOpen = false">
        <div *ngIf="isOpen" class="suggestion-list ">
            <div *ngFor="let ftime of timeList;let last=last">
            <option  (mousedown)="getTimeValue(ftime)">{{ftime}}</option>
         
        </div>
    </div>
    </ng-template> -->
</div>



